<template>
    <div class="promo-card banner skeleton">
        <div class="promo-card__card bg-white">
            <div class="promo-card__actions">
                <div>

                </div>
                <div class="skeleton--edit-button">
                    <SkeletonRow />
                </div>
            </div>
            <div class="promo-card__content">
                <div class="mb-3">
                    <SkeletonRow class="promo-card__image" />
                </div>
                <div class="promo-card__left">
                    <div class="mb-2">
                        <div class="skeleton--title mb-2">
                            <SkeletonRow />
                        </div>
                        <div class="skeleton--text">
                            <SkeletonRow />
                        </div>
                    </div>
                    <div class="mb-2">
                        <div class="skeleton--title mb-2">
                            <SkeletonRow />
                        </div>
                        <div class="skeleton--text">
                            <SkeletonRow />
                        </div>
                    </div>
                    <div>
                        <div class="mb-2">
                            <div class="skeleton--title mb-2">
                                <SkeletonRow />
                            </div>
                            <div class="skeleton--text">
                                <SkeletonRow />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="promo-card__footer">
                <div class="d-flex">
                    <div class="skeleton--date mr-auto">
                        <SkeletonRow />
                    </div>
                    <div class="skeleton--active">
                        <SkeletonRow />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SkeletonRow from '@/components/custom/skeleton/skeletonRow.vue'
export default {
  name: 'Banner-skeleton',
  components: {
    SkeletonRow,
  },
}
</script>

<style lang="scss" src="../style.module.scss" />
